import { ArrowRight } from "lucide-react"

import { buttonVariants } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import InsiderPostButton from "./InsiderPostButton"
import { formatDollars } from "./format"

// Subscribe = POST /insider. The red button is the only red on the offer page
// besides the price cards' top edge.
export function SubscribeButton({ endpoints, className, formClassName, tabIndex }) {
  return (
    <InsiderPostButton
      action={endpoints?.subscribe}
      formClassName={formClassName}
      tabIndex={tabIndex}
      className={cn(buttonVariants(), "h-auto px-[16px] py-[12px] text-[14px] font-bold", className)}
    >
      Subscribe <ArrowRight strokeWidth={2.2} />
    </InsiderPostButton>
  )
}

export function PlanPrice({ plan }) {
  return (
    <div className="flex items-baseline gap-[6px]">
      <span className="font-display text-[34px] leading-none font-bold tracking-[-1px] text-foreground">
        {formatDollars(plan?.amountCents)}
      </span>
      <span className="text-[14px] text-ink-3">/month</span>
    </div>
  )
}

// Price, Subscribe and the fine print on a raised card with a red top edge.
// Used by the offer hero and again beside the FAQ.
export default function PriceCard({ plan, endpoints, fine, className, children }) {
  return (
    <div
      className={cn(
        "flex flex-col gap-[14px] rounded-[14px] border border-t-[3px] border-line-2 border-t-primary bg-card p-[20px] shadow-[0_18px_40px_-24px_rgba(0,0,0,0.3)]",
        className
      )}
    >
      <PlanPrice plan={plan} />
      <SubscribeButton endpoints={endpoints} formClassName="block" className="w-full" />
      <p className="text-[12.5px] leading-[1.5] text-ink-3">{fine}</p>
      {children}
    </div>
  )
}
